export const Status = {
  2: { id: 2, labelKey: 'ready', color: 'success' },
  3: { id: 3, labelKey: 'error', color: 'danger' },
  1: { id: 1, labelKey: 'waiting', color: 'warning' },
};
